export type CollabDocKind = "article" | "changelog"

/** The shared document for one language of a docs article or a changelog. */
export function collabDocName(
	kind: CollabDocKind,
	id: string,
	language: string,
): string {
	return `${kind}:${id}:${language}`
}

export function docsCollabName(articleId: string, language: string): string {
	return collabDocName("article", articleId, language)
}

const COLLAB_NAME = /^(article|changelog):([\w-]{1,64}):([A-Za-z-]{2,16})$/

export function parseCollabDocName(
	name: string,
): { kind: CollabDocKind; id: string; language: string } | null {
	const match = COLLAB_NAME.exec(name)
	if (!match?.[1] || !match[2] || !match[3]) return null
	return {
		kind: match[1] as CollabDocKind,
		id: match[2],
		language: match[3],
	}
}
